import React from 'react'
import { IElementProps } from '../../../types/interfaces'
const Separator = (props: IElementProps) => {
  return (
    <>
      {props.visible && (
        <div className="separator">
          {props.defaultValue && (
            <>
              <span>{props.defaultValue}</span>
            </>
          )}
          <div className="separator-line" />
        </div>
      )}
    </>
  )
}
export default Separator
